export enum ActivityType
{
    Comment,
    Edit,
    Label,
    Status,
    Following,
    Deleted
}